"use client";

import Link from "next/link";
import { NAV_LINKS, SITE } from "../lib/site";
import { MessageCircle } from "lucide-react";

export default function DesktopNav() {
  return (
    <nav
      aria-label="Navegación principal"
      className="hidden md:flex items-center gap-1"
    >
      {NAV_LINKS.map((link) => (
        <Link
          key={link.href}
          href={link.href}
          className="rounded-full px-4 py-2 text-[15px] font-semibold text-brand-900/80 transition hover:bg-brand-50 hover:text-brand-900"
        >
          {link.label}
        </Link>
      ))}
      <a
        href={SITE.whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="ml-2 inline-flex items-center gap-2 rounded-full bg-flame-600 px-4 py-2 text-[15px] font-bold text-white shadow-sm transition hover:bg-flame-700 hover:shadow-md"
      >
        <MessageCircle className="size-4" />
        WhatsApp
      </a>
    </nav>
  );
}
